/* eslint-disable */
import React, { useState, useEffect,  useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { useDispatch, useSelector } from 'react-redux'
import { createMetal, updateMetal } from '../../actions/metalActions'
import { useSnackbar } from 'react-simple-snackbar'


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: '#1976D2',
    marginLeft: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const AddMetal = ({ setOpenMetal, openMetal, currentId, setCurrentId }) => {
  const location = useLocation()
  const formRef = useRef();
  const [metalData, setMetalData] = useState({ metalName: '', userId: 0 })
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))
  const dispatch = useDispatch()
  const metal = useSelector((state) => currentId ? state.metals.metals.find((c) => c.id === currentId) : null)
  // eslint-disable-next-line 
  const [openSnackbar, closeSnackbar] = useSnackbar()


  useEffect(() => {
    if (metal && currentId!==null) {
      setMetalData(metal)
    }else {
      setMetalData({ metalName: '', userId: 0 })
    }
  }, [metal])

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('profile')))
    setMetalData({...metalData, userId: user?.result?.id})
  }, [location])


  useEffect(() => {
    var checkId = user?.result?.id
    if (checkId !== undefined) {
      setMetalData({ ...metalData, userId: checkId })
    } 

  }, [location])


  const handleSubmitMetal = (e) => {
    e.preventDefault()

    if (metalData.metalName===""){
       openSnackbar("Metal name is require");
       return;
    }

    
     
    if (currentId) {
      dispatch(updateMetal(currentId, metalData, openSnackbar))
    } else {
      dispatch(createMetal(metalData, openSnackbar))
    }
   
    clear()
    handleClose()
  }

  const clear = () => {
     //setCurrentId(null)
     setMetalData({ metalName: '', userId: 0 })
  }

  const handleClose = () => {
    setOpenMetal(false);
  };

  const inputStyle = {
    display: "block",
    padding: "1.4rem 0.75rem",
    width: "100%",
    fontSize: "0.8rem",
    lineHeight: 1.25,
    color: "#55595c",
    backgroundColor: "#fff",
    backgroundImage: "none",
    backgroundClip: "padding-box",
    borderTop: "0",
    borderRight: "0",
    borderBottom: "1px solid #eee",
    borderLeft: "0",
    borderRadius: "3px",
    transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)"
  }


  return (
    <div>
      <form >
        <Dialog
          onClose={(e, reason) => {
            if (reason !== 'backdropClick') {
              handleClose()
            }
          }}
          aria-labelledby="customized-dialog-title"
          open={openMetal} fullWidth
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose} style={{ paddingLeft: '20px', color: 'white' }}>
            {currentId ? 'Edit Metal' : 'Add New Metal'}
          </DialogTitle>
          <DialogContent dividers>


          <div className="customInputs">
              <input  
                placeholder="Name" 
                style={inputStyle} 
                name='metalName' 
                type='number'  
                onChange={(e) => setMetalData({...metalData, metalName: e.target.value})}
                value={metalData.metalName} 
              />

              
          </div>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleSubmitMetal} variant="contained" style={{ marginRight: '25px' }} >
              Save Metal
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </div>
  );
}

export default AddMetal